import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

export default function PriceFilter ({priceRange, handlePriceChange, maxPrice}) {
    const hasValidRange = Number.isFinite(maxPrice) && maxPrice > 0;

    return (
        <div id="price-filter" style={{marginLeft: '5%', marginRight: '5%', marginTop: '2.5%'}}>
            <h5 style={{ color: 'green', fontWeight: '300' }}>
                Price
            </h5>
            <Box>
                <span></span>
                {hasValidRange ? (
                    <Slider
                        value={priceRange}
                        onChange={handlePriceChange}
                        valueLabelDisplay="auto"
                        min={0}
                        max={maxPrice}
                        step={1}
                        marks
                        sx={{ color: 'green' }}
                    />
                ) : (
                    <p style={{ margin: 0, color: '#666' }}>No price range available.</p>
                )}
            </Box>
        </div>
    )
}
